import getResponseError from './getResponseError';

const getTranslateIdFromResponseError = async (e: any): Promise<string> => {
  const { code } = await getResponseError(e);
  return code ? `error.${code}` : '';
};

export default getTranslateIdFromResponseError;
